var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#BF022B",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 1.5 7 7M8.5 1.5l-7 7"
  }))));
};

export { SvgCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICAgICAgICA8ZyBzdHJva2U9IiNCRjAyMkIiIHN0cm9rZS13aWR0aD0iMyI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAuNSAwLjVMNy41IDcuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIwNTYuMDAwMDAwLCAtNjY1LjAwMDAwMCkgdHJhbnNsYXRlKDIwNDIuMDAwMDAwLCA0NDEuMDAwMDAwKSB0cmFuc2xhdGUoMTUuMDAwMDAwLCAyMjUuMDAwMDAwKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLjUgMC41TDcuNSA3LjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMDU2LjAwMDAwMCwgLTY2NS4wMDAwMDApIHRyYW5zbGF0ZSgyMDQyLjAwMDAwMCwgNDQxLjAwMDAwMCkgdHJhbnNsYXRlKDE1LjAwMDAwMCwgMjI1LjAwMDAwMCkgdHJhbnNsYXRlKDQuMDAwMDAwLCA0LjAwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtNC4wMDAwMDAsIC00LjAwMDAwMCkiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";